import type { ReactNode } from 'react';

export const symbol_view_carousel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-355v-250q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q220-633.88 220-605v250q0 28.87-20.59 49.44Q178.82-285 149.91-285t-49.41-20.56Q80-326.13 80-355Zm260 155q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h280q24 0 42 18t18 42v440q0 24-18 42t-42 18H340Zm400-155v-250q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q880-633.88 880-605v250q0 28.87-20.59 49.44Q838.82-285 809.91-285t-49.41-20.56Q740-326.13 740-355Zm-400 95h280v-440H340v440Zm140-220Z"
		/>
	</svg>
);
